import { render, staticRenderFns } from "./MPopupPageLink.vue?vue&type=template&id=6072f44c&"
import script from "./MPopupPageLink.vue?vue&type=script&lang=ts&"
export * from "./MPopupPageLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports